export default __webpack_public_path__ + "77ba80938b2d76bfabf8a80c163a36be.svg";